import React, { FC } from 'react';
import ReoccurringUsageLimitsSwitcher from '~/view/screens/MarketingScreen/screens/PromocodesScreen/components/ReoccurringUsageLimits/ReoccurringUsageLimitsSwitcher';
import ReoccurringUsageLimitsFields from '~/view/screens/MarketingScreen/screens/PromocodesScreen/components/ReoccurringUsageLimits/ReoccurringUsageLimitsFields';

const ReoccurringUsageLimits: FC = () => {
  return (
    <>
      <ReoccurringUsageLimitsSwitcher />
      <ReoccurringUsageLimitsFields />
    </>
  );
};

export default ReoccurringUsageLimits;
